import { useMemo } from "react";
import { useTranslation } from "react-i18next";

/**
 * @example
 * const banner = useLocalizedImage({
 *   am: BannerAM,
 *   ru: BannerRU,
 *   en: BannerEN,
 * });
 *
 * <img src={banner} alt="Banner" />
 */
export const useLocalizedImage = (
  images: Record<string, string>,
  fallbackLang: string = "en"
): string => {
  const { i18n } = useTranslation();

  return useMemo(() => {
    const currentLang = i18n.language;
    return (
      images[currentLang] ||
      images[fallbackLang] ||
      images[Object.keys(images)[0]]
    );
  }, [images, i18n.language, fallbackLang]);
};
